import React from "react";
import Col from "react-bootstrap/lib/Col";
import { bool, string } from "prop-types";
import { Field, Form, withFormik } from "formik";
import { compose } from "redux";
import { connect } from "react-redux";
import * as Yup from "yup";
import { selectors as sessionSelectors } from "reducers/session";
import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import TextArea from "pages/_components/fields/TextArea";
import TextField from "pages/_components/fields/TextField";
import I18n from "pages/_components/I18n";
import * as i18n from "util/i18n";
import { actions as comexActions } from "reducers/comex";
import { emailRegex } from "util/form";
import PageLoading from "pages/_components/PageLoading";

const FORM_ID = "comex.share";

const Compose = (props) => {
    const { email, isFetching, isValid, dirty } = props;

    const disabled = !isValid || !dirty || isFetching;

    return (
        <PageLoading loading={isFetching}>
            <Container className="container">
                <Form>
                    <Col className="col-12">
                        <div className="view-title">
                            <h2>
                                <I18n id={`${FORM_ID}.drawer.title`} />
                            </h2>
                        </div>
                        <Field
                            component={TextField}
                            idForm={FORM_ID}
                            name="subject"
                            type="text"
                            maxLength={100}
                            hidePlaceholder
                        />
                        <Field component={TextField} idForm={FORM_ID} name="toAddress" type="text" maxLength={100} />
                        <h3>
                            <p>
                                <I18n id={`${FORM_ID}.fromAddress.label`} />
                            </p>
                            {email}
                        </h3>

                        <Field
                            hidePlaceholder
                            hideLabel
                            component={TextArea}
                            idForm={FORM_ID}
                            name="body"
                            maxLength={256}
                        />

                        <Button bsStyle="primary" label={`${FORM_ID}.send`} type="submit" disabled={disabled} />
                    </Col>
                </Form>
            </Container>
        </PageLoading>
    );
};

Compose.propTypes = {
    isFetching: bool.isRequired,
    email: string.isRequired,
    isValid: bool.isRequired,
    dirty: bool.isRequired,
};

const mapsStateToProps = (state) => ({
    isFetching: sessionSelectors.isFetching(state),
    email: sessionSelectors.getUsername(state),
});

export default compose(
    connect(mapsStateToProps),
    withFormik({
        validateOnChange: true,
        validateOnBlur: false,
        enableReinitialize: true,
        mapPropsToValues: () => ({
            toAddress: "",
            body: "",
            tray: "",
            subject: "",
        }),
        validationSchema: () =>
            Yup.object().shape({
                toAddress: Yup.string()
                    .required(i18n.get("comex.share.address.required"))
                    .test(
                        "format",
                        i18n.get("comex.share.invalidAddress"),
                        (value) => !!value && emailRegex.test(value),
                    ),
                body: Yup.string()
                    .trim()
                    .required(i18n.get("comex.share.body.required")),
                subject: Yup.string()
                    .trim()
                    .required(i18n.get("comex.share.subject.required")),
            }),
        handleSubmit: (fields, { props }) => {
            const request = {
                transactionId: props.idTransaction,
                toAddress: fields.toAddress,
                body: fields.body,
                subject: fields.subject,
            };
            props.dispatch(comexActions.sendTransactionTicket(request));
        },
    }),
)(Compose);
